// src/components/Login.js
import React, { useState } from 'react';
import axios from 'axios';
import {baseUrl} from "../../comman/config";
import { useNavigate, useLocation } from 'react-router-dom';
import { EyeIcon, EyeOffIcon } from '@heroicons/react/outline';

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // Where they were headed before being turned around at the door -- see routes/HelmetWrapper.js.
    // The dashboard when they came to the login page of their own accord, and when state carries
    // something other than a destination.
    const from = location.state?.from ?? { pathname: "/" };

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({ username: '', password: '' });

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleLogin = async () => {
        // Clear previous errors
        setErrors({ username: '', password: '' });

        let hasError = false;
        const newErrors = { username: '', password: '' };

        if (!username) {
            newErrors.username = 'Username is required';
            hasError = true;
        }

        if (!password) {
            newErrors.password = 'Password is required';
            hasError = true;
        }

        if (hasError) {
            setErrors(newErrors);
            return;
        }

        // Implement your login API call here
        try {
            
            const response = await axios.post(`${baseUrl}/auth/login`, {
                username: username,
                password:password
            });
            if (response.data.status) {

                localStorage.setItem('userRole', response.data.user.role);
                localStorage.setItem('username', response.data.user.username);
                // The person's name, which is what screens show. username is the login id they
                // typed to get here, and the two are no longer the same string.
                localStorage.setItem('name', response.data.user.name ?? response.data.user.username);
                // The side bar and the per-screen permission lookups are keyed on the user, not
                // just the role, since User Master can narrow one person within their role.
                localStorage.setItem('userId', response.data.user.id);
                navigate(from);
            } else {
                // Handle API errors
                // const errorData = await response.json();
                setErrors({ ...newErrors, general: response.data.msg });
            }
        } catch (error) {
            console.log(error);
            setErrors({ ...newErrors, general: 'An error occurred. Please try again later.' });
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="max-w-md w-full bg-white rounded-lg p-8 shadow-lg">
                <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>
                {errors.general && <p className="text-red-500 text-center mb-4">{errors.general}</p>}
                <form>
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
                            Username
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="username"
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        {errors.username && <p className="text-red-500 text-xs italic">{errors.username}</p>}
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                            Password
                        </label>
                        <div className="relative">
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 pr-10 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                id="password"
                                type={showPassword ? "text" : "password"}
                                placeholder="********"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button
                                type="button"
                                className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                onClick={togglePasswordVisibility}
                            >
                                {showPassword ? (
                                    <EyeOffIcon className="h-5 w-5 text-gray-500" />
                                ) : (
                                    <EyeIcon className="h-5 w-5 text-gray-500" />
                                )}
                            </button>
                        </div>
                        {errors.password && <p className="text-red-500 text-xs italic">{errors.password}</p>}
                    </div>
                    <div className="flex items-center justify-between">
                        <button
                            type="button"
                            onClick={handleLogin}
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        >
                            Sign In
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;